// extracted by mini-css-extract-plugin
module.exports = {"labelsContainer":"styles_labelsContainer__3SDGK","allLabels":"styles_allLabels__LQc9k","label":"styles_label__1SEHj","ellipses":"styles_ellipses__2ssVT"};